import { render, staticRenderFns } from "./AdditionalChargesSummary.vue?vue&type=template&id=8763ac56&scoped=true&"
import script from "./AdditionalChargesSummary.vue?vue&type=script&lang=js&"
export * from "./AdditionalChargesSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalChargesSummary.vue?vue&type=style&index=0&id=8763ac56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8763ac56",
  null
  
)

export default component.exports